module.exports = __webpack_public_path__ + "static/media/universalmais.ae3e5a62.jpg";